import { useEffect } from 'react';
import {
  useBreadcrumbsContext,
  useHeaderContext,
} from '../../../../app/context';
import { LegalPersonListPageContent } from './components/LegalPersonListPageContent';
import { LegalPersonListPageContainer } from './styles';
import { useOriginatorContext } from 'modules/common/OriginatorProvider';
import IdCardIcon from 'app/components/Icons/IdCardIcon';

const LegalPersonListPage = () => {
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { setTitle, resetTitle } = useHeaderContext();
  const { setSelectedOriginator } = useOriginatorContext();

  useEffect(() => {
    setSelectedOriginator(null);
    setItems(
      [
        { to: '/records/legal', label: 'Cadastros' },
        { to: '/records/legal', label: 'Empresas' },
      ],
      <IdCardIcon />,
    );
    return resetBreadcrumbs;
  }, []);

  useEffect(() => {
    setTitle('Empresas');
    return resetTitle;
  }, []);

  return (
    <LegalPersonListPageContainer>
      <LegalPersonListPageContent />
    </LegalPersonListPageContainer>
  );
};

export default LegalPersonListPage;
